// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".receiverTeamText{height:40px;cursor:pointer;line-height:40px}.receiverTeamSubscImg{width:12px}.foo{transition:background-color .5s ease-in}.commonBookCard{width:100%;cursor:pointer;height:60px;border-bottom:1px solid #ddd;padding:.7rem 0;position:relative;overflow:auto}input{background:none}", ""]);
// Exports
module.exports = exports;
